module.exports = __webpack_public_path__ + "img/gzhao.6b7924c6.jpg";